<section class="reports-hub">
  <header class="reports-hub__head">
    <div class="reports-hub__headrow">
      <div>
        <p class="reports-hub__eyebrow">Livestock Bordereau</p>
        <h1 class="reports-hub__title">{{ divisionName }} reports</h1>
      </div>
      <button
        pButton
        type="button"
        class="reports-hub__send"
        label="Send for Approval"
        icon="pi pi-send"
        [disabled]="sending"
        (click)="openSendConfirm()">
      </button>
    </div>
    <p class="reports-hub__subtitle">
      Select a report to load it into a table. Reports tagged
      <span class="tag tag--year">Reinsurance Year</span> prompt for a year.
    </p>
  </header>

  @if (sendError) {
    <p class="reports-hub__error" role="alert">{{ sendError }}</p>
  }

  <app-treasury-status></app-treasury-status>

  @if (reports.length) {
    <div class="reports-hub__grid">
      @for (report of reports; track report.key) {
        <a class="report-card" [routerLink]="['/', division, report.key]">
          <h2 class="report-card__title">{{ report.title }}</h2>
          <p class="report-card__desc">{{ report.description }}</p>
          <div class="report-card__meta">
            @if (report.requiresYear) {
              <span class="tag tag--year">Reinsurance Year</span>
            } @else {
              <span class="tag">All years</span>
            }
          </div>
          <div class="report-card__actions">
            <span class="report-card__open">
              Open <i class="pi pi-arrow-right" aria-hidden="true"></i>
            </span>
            <span class="report-card__xls" aria-hidden="true" title="Exports to Excel">
              <i class="pi pi-file-excel"></i>
            </span>
          </div>
        </a>
      }
    </div>
  } @else {
    <p class="reports-hub__empty">No reports are available for this division yet.</p>
  }
</section>

<p-dialog
  header="Send for approval"
  [(visible)]="confirmVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '26rem' }"
  (onHide)="cancelSend()">
  <div class="dialog-body">
    <p class="dialog-lead">
      Email the {{ divisionName }} approvers that these reports are ready for approval?
    </p>
    <p class="dialog-note">
      They'll get a link to this page and to the Approval Dashboard. Recipients are
      whoever is configured for {{ divisionName }}.
    </p>
    <p class="dialog-note">
      Sending also marks the latest {{ divisionName }} reporting period as reviewed,
      under your name, and it will appear on the Approval Dashboard.
    </p>

    @if (sendError) {
      <p class="dialog-alert" role="alert">{{ sendError }}</p>
    }
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      [disabled]="sending"
      (click)="cancelSend()">
    </button>
    <button
      pButton
      type="button"
      label="Send"
      icon="pi pi-send"
      [disabled]="sending"
      [loading]="sending"
      (click)="confirmSend()">
    </button>
  </ng-template>
</p-dialog>

